import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { PromiseType } from 'utility-types';

import { getDraft } from '@app/store/transport-layer/form/drafts';

export default function useDraft(workspaceId: string, id: string) {
  return useQuery<PromiseType<ReturnType<typeof getDraft>>, AxiosError>(
    ['draft', id],
    () => getDraft(workspaceId, id),
    { enabled: !!workspaceId && !!id }
  );
}
